"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = require("@react-pdf/renderer");
var luxon_1 = require("luxon");
var React = __importStar(require("react"));
var Card_1 = __importDefault(require("../Card"));
var PassFailChip_1 = __importDefault(require("../PassFailChip"));
var style = renderer_1.StyleSheet.create({
    rootContainer: {
        padding: 10,
        border: 1,
        borderColor: "#e1e1e1",
        borderRadius: 3,
        marginBottom: 10,
    },
    headerContainer: {
        alignItems: "center",
        justifyContent: "space-between",
        paddingBottom: 10,
        flexDirection: "row",
    },
    headerText: {
        fontSize: 12,
    },
    text: {
        fontSize: 8,
        fontFamily: "Quicksand",
    },
    bold: {
        fontWeight: 700,
    },
    tableContainer: {
        paddingVertical: 5,
    },
});
var PanelCard = function (_a) {
    var panelName = _a.panelName, instrumentName = _a.instrumentName, _b = _a.addPassFail, addPassFail = _b === void 0 ? false : _b, method = _a.method, accessionDate = _a.accessionDate, panelCompletedDate = _a.panelCompletedDate, _c = _a.passFailResult, passFailResult = _c === void 0 ? "PASS" : _c, table = _a.table, _d = _a.additionalAttributes, additionalAttributes = _d === void 0 ? [] : _d;
    return (React.createElement(Card_1.default, null,
        React.createElement(renderer_1.View, { style: style.headerContainer },
            React.createElement(renderer_1.Text, { style: [style.text, style.headerText, style.bold] },
                panelName,
                " Analysis"),
            addPassFail && React.createElement(PassFailChip_1.default, { result: passFailResult })),
        React.createElement(renderer_1.View, { style: { flexDirection: "row", justifyContent: "space-between" } },
            React.createElement(CardAttribute, { title: "Instrument", value: instrumentName }),
            React.createElement(CardAttribute, { title: "Method", value: method }),
            React.createElement(CardAttribute, { title: "Accession Date", value: accessionDate
                    ? luxon_1.DateTime.fromISO(accessionDate).toLocaleString(luxon_1.DateTime.DATE_SHORT)
                    : "" }),
            React.createElement(CardAttribute, { title: "Panel Completed Date", value: panelCompletedDate
                    ? luxon_1.DateTime.fromISO(panelCompletedDate).toLocaleString(luxon_1.DateTime.DATE_SHORT)
                    : "" })),
        React.createElement(renderer_1.View, { style: style.tableContainer }, table),
        React.createElement(renderer_1.View, { style: { flexDirection: "row", justifyContent: "space-around" } }, additionalAttributes.map(function (attribute) { return (React.createElement(CardAttribute, __assign({}, attribute))); }))));
};
var CardAttribute = function (_a) {
    var title = _a.title, value = _a.value;
    return (React.createElement(renderer_1.Text, { style: style.text },
        title,
        ": ",
        React.createElement(renderer_1.Text, { style: [style.text, style.bold] }, value)));
};
exports.default = PanelCard;
//# sourceMappingURL=index.js.map